'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('webrtc-adapter');
var react = _interopDefault(require('react'));
var audioRecorderPolyfill = _interopDefault(require('audio-recorder-polyfill'));

var dataURLToBlob = function dataURLToBlob(dataURL) {
  var byteString = atob(dataURL.split(',')[1]);
  var mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];

  var arrayBuffer = new ArrayBuffer(byteString.length);
  var uint8Array = new Uint8Array(arrayBuffer);

  for (var i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeString });
};

var consoleErrors = {
  elementNotFound: function elementNotFound(element) {
    console.error("@withGetUserMedia: Missing ID on " + element + " tag");
  },
  missingStream: function missingStream(methodName) {
    console.error("@withGetUserMedia: [Method: " + methodName + "] MediaStream not found\nUse props.getUserMedia to create one before using this method");
  }
};

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var VIDEO_MIME_TYPE = 'video/webm;codecs=vp8';
var AUDIO_MIME_TYPES = ['audio/webm', 'audio/ogg'];

var DEFAULT_CONSTRAINTS = {
  audio: false,
  video: {
    facingMode: 'user'
  }
};

var withGetUserMedia = function withGetUserMedia() {
  var HOCProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var GetUserMedia = function (_React$Component) {
      _inherits(GetUserMedia, _React$Component);

      function GetUserMedia(props) {
        _classCallCheck(this, GetUserMedia);

        var _this = _possibleConstructorReturn(this, (GetUserMedia.__proto__ || Object.getPrototypeOf(GetUserMedia)).call(this, props));

        Object.assign(_this, {
          stopStream: _this.stopStream.bind(_this),
          getUserMedia: _this.getUserMedia.bind(_this),
          takePhoto: _this.takePhoto.bind(_this),
          handleGrantedPermissions: _this.handleGrantedPermissions.bind(_this),
          handleDeniedPermissions: _this.handleDeniedPermissions.bind(_this),

          startRecording: _this.startRecording.bind(_this),
          stopRecording: _this.stopRecording.bind(_this),
          createMediaObjectURL: _this.createMediaObjectURL.bind(_this),
          createMediaRecorder: _this.createMediaRecorder.bind(_this),

          constraints: HOCProps.constraints || DEFAULT_CONSTRAINTS,

          state: {
            recording: false,
            permitted: false,
            asked: false
          }
        });
        return _this;
      }

      _createClass(GetUserMedia, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.stopStream();
        }
      }, {
        key: 'stopStream',
        value: function stopStream() {
          if (!this.stream) return;

          this.stream.getTracks().forEach(function (track) {
            return track.stop();
          });
          this.stream = null;
          this.toggleStreamSrcObject();
          this.setState({ recording: false });
        }
      }, {
        key: 'getUserMedia',
        value: function getUserMedia() {
          var _state = this.state,
              asked = _state.asked,
              permitted = _state.permitted;

          if (asked && permitted && this.stream) return this.toggleStreamSrcObject();

          navigator.mediaDevices.getUserMedia(this.constraints).then(this.handleGrantedPermissions).catch(this.handleDeniedPermissions);
        }
      }, {
        key: 'handleDeniedPermissions',
        value: function handleDeniedPermissions(error) {
          if (this.state.asked) return;
          // TODO: Provide a better way to debug
          console.error(error);
          this.setState({ permitted: false, asked: true });
        }
      }, {
        key: 'handleGrantedPermissions',
        value: function handleGrantedPermissions(stream) {
          this.stream = stream;
          this.toggleStreamSrcObject();
          this.setState({ permitted: true, asked: true });
        }
      }, {
        key: 'createMediaRecorder',
        value: function createMediaRecorder(stream) {
          if (!window.MediaRecorder) {
            var AudioRecorder = audioRecorderPolyfill;
            AudioRecorder.mimeType = 'audio/wav';
            return new AudioRecorder(stream);
          }

          if (!this.constraints.video) {
            return new window.MediaRecorder(stream, { mimeType: this.audioSupportedType });
          }

          return new window.MediaRecorder(stream, { mimeType: VIDEO_MIME_TYPE });
        }
      }, {
        key: 'createMediaObjectURL',
        value: function createMediaObjectURL(_ref) {
          var data = _ref.data;

          if (!data || data.size <= 0 || !data.type) return;

          var mediaBlob = new Blob([data], { type: data.type });

          this.setState({ mediaBlob: mediaBlob, mediaObjectURL: URL.createObjectURL(mediaBlob) });
        }
      }, {
        key: 'startRecording',
        value: function startRecording() {
          if (!this.stream) return consoleErrors.missingStream('startRecording');

          this.mediaRecorder = this.createMediaRecorder(this.stream);
          this.mediaRecorder.addEventListener('dataavailable', this.createMediaObjectURL);
          this.mediaRecorder.start();
          this.setState({ recording: true });
        }
      }, {
        key: 'stopRecording',
        value: function stopRecording() {
          this.mediaRecorder.stop();
          this.setState({ recording: false });
        }
      }, {
        key: 'takePhoto',
        value: function takePhoto() {
          if (!this.stream) return consoleErrors.missingStream('takePhoto');
          if (!this.streamElement) return consoleErrors.elementNotFound('streamElementId');

          var _streamElement = this.streamElement,
              videoWidth = _streamElement.videoWidth,
              videoHeight = _streamElement.videoHeight;

          var canvasElement = document.createElement('canvas');
          canvasElement.height = videoHeight;
          canvasElement.width = videoWidth;
          canvasElement.getContext('2d').drawImage(this.streamElement, 0, 0);

          var photo = canvasElement.toDataURL('image/png');
          var photoBlob = dataURLToBlob(photo);

          this.setState({ photo: photo, photoBlob: photoBlob });
        }
      }, {
        key: 'toggleStreamSrcObject',
        value: function toggleStreamSrcObject() {
          if (!HOCProps.streamElementId) return;
          if (!this.streamElement) return consoleErrors.elementNotFound('streamElementId');

          if (!this.stream) {
            this.streamElement.srcObject = null;
          }

          this.streamElement.srcObject = this.stream;
        }
      }, {
        key: 'render',
        value: function render() {
          return react.createElement(Component, _extends({
            stopStream: this.stopStream,
            getUserMedia: this.getUserMedia,
            takePhoto: this.takePhoto,
            startRecording: this.startRecording,
            stopRecording: this.stopRecording,
            stream: this.stream
          }, HOCProps, this.state, this.props));
        }
      }, {
        key: 'streamElement',
        get: function get() {
          var streamElementNode = document.getElementById(HOCProps.streamElementId);

          streamElementNode.setAttribute('autoPlay', true);
          streamElementNode.setAttribute('playsInline', true);

          return streamElementNode;
        }
      }, {
        key: 'audioSupportedType',
        get: function get() {
          return AUDIO_MIME_TYPES.find(function (type) {
            return window.MediaRecorder.isTypeSupported(type);
          });
        }
      }]);

      return GetUserMedia;
    }(react.Component);

    var displayName = Component.displayName || Component.name || 'Component';
    GetUserMedia.displayName = 'withGetUserMedia(' + displayName + ')';
    return GetUserMedia;
  };
};

withGetUserMedia.version = react.version;

var src = { withGetUserMedia: withGetUserMedia };
var src_1 = src.withGetUserMedia;

exports.default = src;
exports.withGetUserMedia = src_1;
//# sourceMappingURL=react-get-user-media.js.map
